// import React, { useState, useMemo } from "react";
// import ReactApexChart from "react-apexcharts";

// const getUniqueSeasons = (data) => {
//   const seasons = data.map((item) => item.season);
//   return [...new Set(seasons)];
// };

// const getUniqueYears = (data) => {
//   const years = data.flatMap((item) =>
//     item.indices.map((element) => new Date(element.date).getFullYear())
//   );
//   return [...new Set(years)];
// };

// const getMonthsBySeason = (season) => {
//   if (season === "Rabi") {
//     return ["Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun"];
//   } else if (season === "Kharif") {
//     return ["May", "Jun", "Jul", "Aug", "Sep", "Oct", ""];
//   }
//   return [];
// };

// const BankerIndices = ({ data }) => {
//   const seasons = useMemo(() => getUniqueSeasons(data), [data]);
//   const years = useMemo(() => getUniqueYears(data), [data]);
//   const [selectedType, setSelectedType] = useState("NDVI");
//   const [selectedSeason, setSelectedSeason] = useState(seasons[0]);

//   const filterData = (data, type, season) => {
//     return data
//       .filter((item) => item.season === season)
//       .flatMap((item) =>
//         item?.summary_stats?.map((element) => ({
//           type: parseFloat(element[type]),
//           date: new Date(element.date),
//           month: new Date(element.date).toLocaleString("default", {
//             month: "short",
//           }),
//           year: new Date(element.date).getFullYear(),
//         }))
//       );
//   };

//   const filteredData = useMemo(
//     () => filterData(data, selectedType, selectedSeason),
//     [data, selectedType, selectedSeason]
//   );

//   const uniqueMonths = useMemo(() => getMonthsBySeason(selectedSeason), [
//     selectedSeason,
//     data,
//   ]);

//   const getSeriesData = () => {
//     return years.map((year) => {
//       const filteredData = data
//         .filter((item) => item.season === selectedSeason)
//         .flatMap((item) => item?.indices)
//         .filter((element) => new Date(element?.date).getFullYear() === year);

//       const seriesData = uniqueMonths.map((month) => {
//         const monthData = filteredData.filter(
//           (item) =>
//             new Date(item.date).toLocaleString("default", {
//               month: "short",
//             }) === month
//         );

//         if (monthData.length === 0) {
//           return null;
//         }

//         const maxValue = Math.max(
//           ...monthData.map((item) => parseFloat(item[selectedType]))
//         );

//         return maxValue;
//       });

//       return {
//         name: year.toString(),
//         data: seriesData,
//       };
//     });
//   };

//   const seriesData = useMemo(() => getSeriesData(), [
//     filteredData,
//     years,
//     uniqueMonths,
//   ]);

//   if (!seriesData.length) return null;

//   const state = {
//     options: {
//       chart: {
//         height: 350,
//         type: "area",
//         zoom: {
//           enabled: false,
//         },
//       },
//       dataLabels: {
//         enabled: false,
//       },
//       stroke: {
//         curve: "smooth",
//       },
//       grid: {
//         row: {
//           colors: ["#f3f3f3", "transparent"],
//           opacity: 0.5,
//         },
//       },
//       fill: {
//         type: "gradient",
//         gradient: {
//           shade: "light",
//           type: "vertical",
//           shadeIntensity: 0.5,
//           gradientToColors: ["#3498db", "#e74c3c", "#2ecc71", "#f39c12"], 
//           inverseColors: false,
//           opacityFrom: 0.5,
//           opacityTo: 0.1,
//           stops: [0, 100],
//         },
//       },

//       xaxis: {
//         categories: uniqueMonths,
//         labels: {
//           style: {
//             fontSize: "12px",
//           },
//         },
//         tickAmount: uniqueMonths.length * 4,
//         tickPlacement: "between",
//       },
//       yaxis: {
//         labels: {
//           formatter: function(value) {
//             return value !== null ? value.toFixed(2) : "-";
//           },
//         },
//       },
//       markers: {
//         size: 5,
//         hover: {
//           size: 7,
//         },
//         discrete: [],
//       },
//       tooltip: {
//         enabled: true,
//         shared: true,
//         intersect: false,
//         x: {
//           formatter: function(value) {
//             return uniqueMonths.includes(value) ? value : "N/A";
//           },
//         },
//         y: {
//           formatter: function(value) {
//             return value !== null ? value.toFixed(2) : "-";
//           },
//         },
//         marker: {
//           show: true,
//         },
//       },
//       legend: {
//         position: "bottom",
//         horizontalAlign: "center",
//         floating: false,
//         offsetY: 0,
//       },
//       colors: ["#3498db", "#e74c3c", "#2ecc71", "#f39c12"],
//     },
//     series: seriesData,
//   };

//   return (
//     <React.Fragment>
//       <div className="season-selector">
//         <label htmlFor="typeSelect" className="season-label">
//           Select Type:
//         </label>
//         <select
//           value={selectedType}
//           className="season-dropdown"
//           onChange={(e) => setSelectedType(e.target.value)}
//         >
//           <option value="NDVI">NDVI</option>
//           <option value="NDMI">NDMI</option>
//         </select>
//         &nbsp;&nbsp;
//         <label htmlFor="seasonSelect" className="season-label">
//           Select Season:
//         </label>
//         <select
//           id="seasonSelect"
//           className="season-dropdown"
//           value={selectedSeason}
//           onChange={(e) => setSelectedSeason(e.target.value)}
//         >
//           {seasons.map((season) => (
//             <option key={season} value={season}>
//               {season}
//             </option>
//           ))}
//         </select>
//       </div>
//       <ReactApexChart
//         options={state.options}
//         series={state.series}
//         type="area"
//         height={350}
//       />
//     </React.Fragment>
//   );
// };

// export default BankerIndices;


import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

const getUniqueYears = (data) => {
  const years = data.flatMap((item) =>
    item.indices.map((element) => new Date(element.date).getFullYear())
  );
  return [...new Set(years)];
};

const getMonthsBySeason = (season) => {
  return season === "Rabi"
    ? ["Dec", "Jan", "Feb", "Mar", "Apr", "May"]
    : [ "Jun", "Jul", "Aug", "Sep", "Oct", "Nov"];
};

const BankerIndices = ({ data }) => {
  const years = useMemo(() => getUniqueYears(data), [data]);
  const types = ["NDVI", "NDMI"];
  const seasons = ["Kharif", "Rabi"];

  const getSeriesData = (selectedType, selectedSeason) => {
    const uniqueMonths = getMonthsBySeason(selectedSeason);

    return years.map((year) => {
      const filteredData = data
        .filter((item) => item.season === selectedSeason)
        .flatMap((item) => item?.indices)
        .filter((element) => new Date(element?.date).getFullYear() === year);

      const seriesData = uniqueMonths.map((month) => {
        const monthData = filteredData.filter(
          (item) =>
            new Date(item.date).toLocaleString("default", { month: "short" }) ===
            month
        );

        if (monthData.length === 0) return null;

        const maxValue = Math.max(
          ...monthData.map((item) => parseFloat(item[selectedType]))
        );

        return maxValue;
      });

      return {
        name: year.toString(),
        data: seriesData,
      };
    });
  };

  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
      {types.map((type) =>
        seasons.map((season) => {
          const seriesData = getSeriesData(type, season);
          if (!seriesData.length) return null;

          const chartOptions = {
            chart: {
              height: 350,
              type: "area",
              zoom: { enabled: false },
            },
            dataLabels: { enabled: false },
            stroke: { curve: "smooth" },
            grid: {
              row: { colors: ["#f3f3f3", "transparent"], opacity: 0.5 },
            },
            fill: {
              type: "gradient",
              gradient: {
                shade: "light",
                type: "vertical",
                shadeIntensity: 0.5,
                gradientToColors: ["#3498db", "#e74c3c", "#2ecc71", "#f39c12"],
                inverseColors: false,
                opacityFrom: 0.5,
                opacityTo: 0.1,
                stops: [0, 100],
              },
            },
            xaxis: {
              categories: getMonthsBySeason(season),
              labels: { style: { fontSize: "12px" } },
              tickAmount: getMonthsBySeason(season).length * 4,
              tickPlacement: "between",
            },
            yaxis: {
              labels: {
                formatter: (value) => (value !== null ? value.toFixed(2) : "-"),
              },
            },
            markers: {
              size: 5,
              hover: { size: 7 },
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              x: {
                formatter: (value) =>
                  getMonthsBySeason(season).includes(value) ? value : "N/A",
              },
              y: {
                formatter: (value) => (value !== null ? value.toFixed(2) : "-"),
              },
            },
            legend: {
              position: "bottom",
              horizontalAlign: "center",
            },
            colors: ["#3498db", "#e74c3c", "#2ecc71", "#f39c12"],
          };

          return (
            <div key={`${type}-${season}`}>
              <h5 style={{ textAlign: "center" }}>
                {type} - {season}
              </h5>
              <ReactApexChart options={chartOptions} series={seriesData} type="area" height={300} />
            </div>
          );
        })
      )}
    </div>
  );
};

export default BankerIndices;
